import { render, staticRenderFns } from "./MultiSelectTable.vue?vue&type=template&id=6cfe1fa7&scoped=true"
import script from "./MultiSelectTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelectTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MultiSelectTable.vue?vue&type=style&index=0&id=6cfe1fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe1fa7",
  null
  
)

export default component.exports